import { inject, injectable, injectFromBase } from 'inversify'
import { DomainSettings } from '@/decorators/domainDecorators'
import DomainBaseService from '@/services/domain/domainBaseService'
import DeletedEntity from '@/data/models/DeletedEntity'
import type DeletedEntityRepository from '@/data/repositories/deletedEntityRepository'
import type TranslateService from '@/services/translateService'
import { SERVICE_TYPES } from '@/core/container/types'

@DomainSettings({
  model: DeletedEntity,
})
@injectable()
@injectFromBase()
export default class DeletedEntityService extends DomainBaseService<DeletedEntityRepository> {
  @inject(SERVICE_TYPES.TranslateService) protected readonly translateService: TranslateService

  public markManyAsDeleted(entityType: string, entityIds: string[]) {
    if (!entityIds.length) {
      return
    }

    return this.getDomainRepository().insertOrUpdateRaw(
      entityIds.map((entityId) => ({
        id: this.getDeletedEntityId(entityType, entityId),
        entityType,
        entityId,
      })),
    )
  }

  public isDeleted(entityType: string, entityId: string) {
    return this.findEntityByIdOrNull(this.getDeletedEntityId(entityType, entityId)) !== null
  }

  public getDeletedEntityLabel(entityType: string) {
    const entityTextKey = `entities.${entityType}.name`
    const entityLabel = this.translateService.exists(entityTextKey)
      ? this.translateService.t(entityTextKey)
      : entityType

    return this.translateService.t('entities.deletedEntity', { entity: entityLabel })
  }

  protected getDeletedEntityId(entityType: string, entityId: string) {
    return `${entityType}-${entityId}`
  }
}
